export const LandingPageDomainPreference = {
  Default: 'Default', // 0
  Subdomain: 'Subdomain', // 10
  Domain: 'Domain' // 20
}
